import { textColor, borderColor } from './color';
export default {
  axisLine: {
    show: true,
    lineStyle: {
      color: '#ffffff'
    }
  },
  axisTick: {
    show: true,
    lineStyle: {
      color: '#ffffff'
    }
  },
  axisLabel: {
    show: true,
    textStyle: {
      color: textColor.gray
    }
  },
  splitLine: {
    show: true,
    lineStyle: {
      type: 'dashed',
      color: [borderColor.gray]
    }
  },
  splitArea: {
    show: false,
    areaStyle: {
      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    }
  }
};